import { SCORECARD_ACTIONS } from "constants/actions";

export function fetchScoreCard(case_id, scorecard_type = 1) {
    return {
        type: SCORECARD_ACTIONS.FETCH_SCORECARD,
        payload: {
            case_id,
            scorecard_type
        }
    };
}
export function fetchedScoreCard(case_id, scorecard_type = 1, scorecard) {
    return {
        type: SCORECARD_ACTIONS.FETCHED_SCORECARD,
        payload: {
            case_id,
            scorecard_type,
            scorecard
        }
    };
}
export function failedFetchScoreCard(case_id, error) {
    return {
        type: SCORECARD_ACTIONS.FAILED_FETCH_SCORECARD,
        payload: {
            case_id
        },
        error
    };
}

export function generateScoreCard(case_id, scorecard_type = 1) {
    return {
        type: SCORECARD_ACTIONS.GENERATE_SCORECARD,
        payload: {
            case_id,
            scorecard_type
        }
    };
}

export function generatedScoreCard(case_id, scorecard_type = 1) {
    return {
        type: SCORECARD_ACTIONS.GENERATED_SCORECARD,
        payload: {
            case_id,
            scorecard_type
        }
    };
}

export function failedGenerateScoreCard(case_id, error) {
    return {
        type: SCORECARD_ACTIONS.FAILED_GENERATE_SCORECARD,
        payload: {
            case_id
        },
        error
    };
}
